// const BaseUrl = "http://busapi.buscrs.com/api";
// const BaseUrl = "https://busapi.mavenconnect.tech/api";  // biz
// let BaseUrl = "https://stagebusapi.mavenconnect.tech/api"   // tech
// if (window.location.origin.includes('mavenconnect.tech')) { BaseUrl = 'https://stagebusapi.mavenconnect.tech/api' }
// else if (window.location.origin.includes('mavenconnect.biz')) { BaseUrl = ('https://busapi.mavenconnect.tech/api') }

import { isEmpty } from "../../utilityFunctions";

//ksrtc url
// export let BaseUrl = "https://oprsapi.amnex.co.in/api"; // tech
export let BaseUrl = "https://oprsapi.amnex.co.in/api";//live
// export let BaseUrl = "https://awatarapi.ksrtc.in/api"
const axios = require("axios");

//KSRTC Microsite base URL
export let BaseUrlV2 = "https://betaksrtcms.amnex.co.in/api"
// export let BaseUrlV2 = "https://ksrtc.in/api";
export let BaseUrlForCargoReport = "https://stagecargoapi.mavenconnect.tech/api";//tech
//export let BaseUrlForCargoReport = "https://cargoapi.mavenconnect.tech/api"; //live
// For Post Api Calls And Put
const HttpCall = async (url, method, params, body) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrl + url;
    const token = localStorage.getItem("token");
    axios({
      method: method,
      url: completeUrl,
      data: body,
      params: {
        ...params,
      },
      headers: {
        Accept: "application/json",
        Token: token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

// For Get Api Calls
const HttpGet = async (url, params, logintoken = null) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrl + url;
    const token = localStorage.getItem("token");
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
      },
      headers: {
        Accept: "application/json",
        Token: logintoken === null ? token : logintoken,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
const HttpGetWithCancel = async (url, params, cancelToken) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrl + url;
    const token = localStorage.getItem("token");
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
      },
      headers: {
        Accept: "application/json",
        Token: token,
      },
      cancelToken
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
const HttpCallV2 = async (url, method, params, body) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrlV2 + url;
    const token = localStorage.getItem("token");
    axios({
      method: method,
      url: completeUrl,
      data: body,
      // params: {
      //   ...params,
      // }
      // headers: {
      //   Accept: "application/json",
      //   Token: token,
      // },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

// For Get Api Calls
const HttpGetV2 = async (url, params) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrlV2 + url;
    const token = localStorage.getItem("token");
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
      }
      // headers: {
      //   Accept: "application/json",
      //   Token: token,
      // },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const callApiForArray = (apiUrl, dataArray) => {
  let successCount = 0;
  let errorCount = 0;

  const promises = dataArray.map((data) => {
    return HttpCall(apiUrl, "post", {}, data)
      .then((res) => {
        successCount++;
        return res;
      })
      .catch((err) => {
        errorCount++;
        // Instead of throwing the error, return it so Promise.all continues
        return err;
      });
  });

  return Promise.all(promises)
    .then((responses) => {
      // return [responses, successCount, errorCount];
      return [responses, successCount, errorCount];
    })
    .catch((err) => {
      console.error(`Error count: ${errorCount}`);
      throw err;
    });
};


const memoizedGet = () => {
  const memcache = new Map()
  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    if (isCache) {
      const selector = JSON.stringify(args)
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const completeUrl = BaseUrl + url;
      let queryParams = ''
      const postData = args[1]
      if (typeof postData != 'undefined' && !isEmpty(postData)) {
        Object.entries(postData).forEach((entry) => {
          const [key, value] = entry
          queryParams += `${key}=${value}&`
        })
        url = `${url}${queryParams}`
      }
      return new Promise(async function (resolve, reject) {
        const token = localStorage.getItem("token");
        axios({
          method: "get",
          url: completeUrl,
          params: {
            ...postData,
          },
          headers: {
            Accept: "application/json",
            Token: token,
          },
        }).then((response) => {
          let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
          if (response && response.status === 200) {
            memcache.set(selector, { data: response, timestamp: Date.now(), duration: cacheDuration })
            return resolve(response);
          }
          return resolve(response);
        })
          .catch((err) => {
            return reject(err);
          });
      })
    } else {
      let url = args[0]
      const postData = args[1]
      return HttpGet(url, postData)
    }
  }
}
const HttpGetV3 = async (url, params, logintoken = null) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrlForCargoReport + url;
    const token = localStorage.getItem("token");
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
      },
      headers: {
        Accept: "application/json",
        Token: logintoken === null ? token : logintoken,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const GetRequestCached = memoizedGet();
export default {
  HttpCall,
  HttpGet,
  callApiForArray,
  GetRequestCached,
  HttpCallV2,
  HttpGetV2,
  HttpGetWithCancel,
  HttpGetV3
};